module.exports = __webpack_public_path__ + "img/category-sport-hover.38bf3ca8.png";